"use strict";
var trip_dates_component_1 = require("./trip-dates.component");
exports.TripDatesComponent = trip_dates_component_1.TripDatesComponent;
var trip_destination_component_1 = require("./trip-destination.component");
exports.TripDestinationComponent = trip_destination_component_1.TripDestinationComponent;
var trip_providers_component_1 = require("./trip-providers.component");
exports.TripProvidersComponent = trip_providers_component_1.TripProvidersComponent;
var trip_details_component_1 = require("./trip-details.component");
exports.TripDetailsComponent = trip_details_component_1.TripDetailsComponent;
var trip_details_module_1 = require("./trip-details.module");
exports.TripDetailsModule = trip_details_module_1.TripDetailsModule;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/trip-details/index.js